import React from "react";

import EventStats from "./components/EventStats";
import EventFilters from "./components/EventFilters";
import EventsTable from "./components/EventsTable";
import EventsMobileList from "./components/EventsMobileList";
import EventDetailsDrawer from "./components/EventDetailsDrawer";
import EventsPagination from "./components/EventsPagination";
import EventsSkeleton from "./components/EventsSkeleton";
import EventsEmptyState from "./components/EventsEmptyState";

import useScrollToTop from "../../../hooks/useScollToTop";
import { useAdminEvents } from "./hooks/useAdminEvents";

function EventList() {
  useScrollToTop();

  const {
    filteredEvents,
    paginatedEvents,
    filters,
    stats,
    typeOptions,
    levelOptions,
    categoryOptions,
    selectedEvent,
    isDrawerOpen,
    loading,
    refreshing,
    page,
    totalPages,
    fetchEvents,
    updateFilter,
    resetFilters,
    setPage,
    openEventDrawer,
    closeEventDrawer,
    handleDeleteEvent,
  } = useAdminEvents();

  const hasFilters = Boolean(
    filters.search ||
      filters.status ||
      filters.type ||
      filters.level ||
      filters.category ||
      filters.shared,
  );

  return (
    <div className="w-full space-y-6 font-satoshi">
      {loading ? (
        <EventsSkeleton />
      ) : (
        <>
          <EventStats stats={stats} />

          <EventFilters
            filters={filters}
            typeOptions={typeOptions}
            levelOptions={levelOptions}
            categoryOptions={categoryOptions}
            refreshing={refreshing}
            onChange={updateFilter}
            onReset={resetFilters}
            onRefresh={() => fetchEvents({ silent: false })}
          />

          {paginatedEvents.length > 0 ? (
            <>
              <EventsTable
                events={paginatedEvents}
                onOpen={openEventDrawer}
                onDelete={handleDeleteEvent}
              />

              <EventsMobileList
                events={paginatedEvents}
                onOpen={openEventDrawer}
                onDelete={handleDeleteEvent}
              />

              <EventsPagination
                page={page}
                totalPages={totalPages}
                perPage={filters.perPage}
                totalItems={filteredEvents.length}
                onPageChange={setPage}
                onPerPageChange={updateFilter}
              />
            </>
          ) : (
            <EventsEmptyState
              hasFilters={hasFilters}
              onReset={resetFilters}
            />
          )}

          <EventDetailsDrawer
            isOpen={isDrawerOpen}
            event={selectedEvent}
            onClose={closeEventDrawer}
            onDelete={handleDeleteEvent}
          />
        </>
      )}
    </div>
  );
}

export default EventList;